import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import get from "lodash/get";
import setupFetch from "src/utils/setupFetch";

export type Student = {
  _id: string;
  firstName: string;
  lastName: string;
  avatar: string;
  currentAttendance?: string;
};

export type StudentSlice = {
  students: Student[];
};

const {
  actionCreator: fetchStudents,
  saga: fetchStudentsSaga,
  reducer: fetchStudentsReducer,
} = setupFetch({
  stateKey: "students",
  makePath: ({ classId }: { classId: string }) => `/api/dojoClass/${classId}/student`,
  makeUpdatePath: () => "students",
});

type Selector = (state: StudentSlice) => Student[] | null;

export { fetchStudents };

const ATTENDING_STATUSES = new Set(["present", "tardy"]);
export const selectAttendingStudents: Selector = (state: StudentSlice) => {
  // state is definitely not a StudentSlice, but lodash get allows us to pretend
  const studentsObject: Record<string, Student> | null = get(state, ["students", "students"]);
  if (!studentsObject) return null;
  const students = Object.values(studentsObject);
  return students.filter(({ currentAttendance }) => currentAttendance && ATTENDING_STATUSES.has(currentAttendance));
};

const reducer = combineActionHandlers({}, [fetchStudentsReducer]);

const install: PodInstallFunction = (installReducer, installSaga) => {
  installReducer("students", reducer);
  installSaga(fetchStudentsSaga);
};

export default install;
